import React, { createRef, useEffect, useState } from "react";
import axiosHelper from "../../../helpers/axios-helper";
// import TempNav from "../../shared/TempNav";
import "../../../styles/pages/login.css";
import { useForm } from "react-hook-form";
import { errorMessage, waitButton } from "../../../helpers/form-helper";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";
import qs from "query-string";
import config from "../../../helpers/config";

export default function WebResetPasswordLevel2() {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({});
  const rcref = createRef();
  const [rctoken, changeRCtoken] = useState("");
  const nav = useNavigate();

  const [code, setCode] = useState("");
  useEffect(() => {
    const queryParams = qs.parse(window.location.search);
    if (queryParams?.c) {
      setCode(queryParams.c);
    }
  }, []);

  const onSubmit = (data) => {
    if (!rctoken) {
      return;
    }

    axiosHelper
      .post(
        "/playerweb/resetpasswordlevel2?rctoken=" + rctoken,
        { ...data, code }
      )
      .then((response) => {
        console.log(response);

        toast.success(response.data);
        nav("/player/weblogin");
      })
      .catch((error) => {
        rcchange(null);
        window.grecaptcha.reset();
        axiosHelper.handleError(error, "Password reset failed");
      });
  };
  // if (errors) {
  //   console.error(errors);
  // }

  const rcchange = (rcval) => {
    console.log("rcval: " + rcval);
    changeRCtoken(rcval);
  };

  if (code) {
    return (
      <div className="login-container">
        <main className="form-signin">
          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <img className="mb-4" src="/logo.png" alt="" height="100" />
            <h1 className="h3 mb-3 fw-normal">Şifremi Sıfırla</h1>

            <div className="form-floating">
              <input
                type="password"
                className="form-control"
                id="fPassword"
                placeholder="Password"
                maxLength="50"
                {...register("password", { required: true, maxLength: 50 })}
              />
              <label htmlFor="fPassword">Password</label>
              {errorMessage(errors.password, "required", "Password is required")}
            </div>

            <div className="form-floating">
              <ReCAPTCHA
                ref={rcref}
                sitekey={config.rcSiteKey}
                hl="tr"
                onChange={rcchange}
              />
            </div>

            <button
              disabled={isSubmitting}
              className="w-100 btn btn-lg btn-primary"
              type="submit"
            >
              {waitButton(isSubmitting)}
              {!isSubmitting && "Change"}
            </button>
          </form>
        </main>
      </div>
    );
  } else {
    return "";
  }
}
